import OcrUploader from "./ocrUploader";

export default OcrUploader;
